import { createBrowserRouter, Navigate } from 'react-router-dom';
import { lazy, Suspense, type ComponentType } from 'react';
import { AuthLayout } from './layouts/AuthLayout';
import { ProtectedLayout } from './layouts/ProtectedLayout';
import { PageLoader } from '../components/core/PageLoader';

function withSuspense(Component: ComponentType) {
  return (
    <Suspense fallback={<PageLoader />}>
      <Component />
    </Suspense>
  );
}

const LoginPage = lazy(() => import('../views/auth/Login'));
const ForgotPage = lazy(() => import('../views/auth/Forgot'));
const HomePage = lazy(() => import('../views/Home'));
const UserPage = lazy(() => import('../views/User'));
const CursoPage = lazy(() => import('../views/CursoTab'));
const CursoDetallePage = lazy(() => import('../views/Curso/components/CursoDetalle'));
const CalendarPage = lazy(() => import('../views/Calendar'));
const PermisoPage = lazy(() => import('../views/Permission'));
const KardexPage = lazy(() => import('../views/Kardex'));
const ReporteSemanalPage = lazy(() => import('../views/Report-Semanal'));
const ReportePage = lazy(() => import('../views/Report'));
const NotificacionesPage = lazy(() => import('../views/Notifications'));
const LibroDeCursoPage = lazy(() => import('../views/LibroDeCurso'));
const KinderAsistenciaPage = lazy(() => import('../views/AsistenciaKinder'));
const AyudaPage = lazy(() => import('../views/Ayuda'));
const CircularesPage = lazy(() => import('../views/Circulares'));
const TicketPage = lazy(() => import('../views/Ticket'));
const CertificatesPage = lazy(() => import('../views/Certificates'));
const StudentPhotosPage = lazy(() => import('../views/StudentPhotos'));
const SeminarsPage = lazy(() => import('../views/Seminars'));

export const router = createBrowserRouter([
  {
    path: '/auth',
    element: <AuthLayout />,
    children: [
      { path: 'login', element: withSuspense(LoginPage) },
      { path: 'forgot', element: withSuspense(ForgotPage) },
      { index: true, element: <Navigate to="login" replace /> },
    ],
  },
  {
    path: '/',
    element: <ProtectedLayout />,
    children: [
      { path: 'home', element: withSuspense(HomePage) },
      { path: 'users', element: withSuspense(UserPage) },
      { path: 'courses', element: withSuspense(CursoPage) },
      { path: 'courses/:cursoId', element: withSuspense(CursoDetallePage) },
      { path: 'calendar', element: withSuspense(CalendarPage) },
      { path: 'permission', element: withSuspense(PermisoPage) },
      { path: 'kardex', element: withSuspense(KardexPage) },
      { path: 'report-semanal', element: withSuspense(ReporteSemanalPage) },
      { path: 'reports', element: withSuspense(ReportePage) },
      { path: 'notifications', element: withSuspense(NotificacionesPage) },
      { path: 'course-book', element: withSuspense(LibroDeCursoPage) },
      { path: 'kinder-asistencia', element: withSuspense(KinderAsistenciaPage) },
      { path: 'help', element: withSuspense(AyudaPage) },
      { path: 'circulares', element: withSuspense(CircularesPage) },
      { path: 'ticket', element: withSuspense(TicketPage) },
      { path: 'certificates', element: withSuspense(CertificatesPage) },
      { path: 'student-photos', element: withSuspense(StudentPhotosPage) },
      { path: 'seminars', element: withSuspense(SeminarsPage) },
      { index: true, element: <Navigate to="home" replace /> },
    ],
  },
  {
    path: '*',
    element: (
      <div style={{ padding: 32, textAlign: 'center' }}>
        <h2>404 — Página no encontrada</h2>
      </div>
    ),
  },
]);
